import React, { Component } from 'react';

import { api } from '../../services/api';
import { session } from '../../services/session';
import { dateService } from '../../services/date';

import './created-links.scss';
import dynamicInfo from '../../images/icons/dynamic-info.svg';

import BasicDropdown from '../base/dropdowns/basic-dropdown';
import BaseModal from '../base/modals/base-modal';

class CreatedLinks extends Component {
  constructor(props) {
    super(props);

    this.filterOptions = [
      {
        label: 'All Links',
        value: 'all',
      },
      {
        label: 'Created by You',
        value: 'by_user',
      },
      {
        label: 'Created by Team',
        value: 'by_team',
      },
      {
        label: 'Created by Narrativ',
        value: 'by_admin',
      },
    ];

    this.state = {
      smartLinks: [],
      copiedLinkID: null,
      isInfoModalOpened: false,
      selectedFilter: this.filterOptions[0],
    };
  }

  componentDidMount() {
    this.loadSmartLinks();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selectedFilter.label !== this.state.selectedFilter.label) {
      this.loadSmartLinks();
    }
  }

  loadSmartLinks() {
    return api
      .get(
        `/api/v2/publishers/${session.orgId}/smart_links/list/${this.state.selectedFilter.value}/`,
      )
      .then(response => {
        return this.setState({ smartLinks: response.data.data });
      });
  }

  async copy(link) {
    try {
      await navigator.clipboard.writeText(link.auction_url);
      this.setState({ copiedLinkID: link.bam_link_id });
    } catch (err) {
      console.error('Failed to copy link: ', err);
    }
  }

  dismiss() {
    this.setState({ isInfoModalOpened: false });
  }

  render() {
    const infoModalElem = this.state.isInfoModalOpened ? (
      <BaseModal
        options={{
          identifier: 'remove-override',
          displayTxt: `The recently created links below should only be copied into the story name with which
					 it was originally created (Listed right below the smartlink).  If you plan to recommend the same
					 product on a different story, please create a new link.  This helps ensure you and your brands
					 can track performance on the right stories`,
          cancel: {
            txt: 'Okay',
            callback: this.dismiss.bind(this),
          },
        }}
      ></BaseModal>
    ) : null;

    const smartLinks = this.state.smartLinks.map(smartLink => {
      const dateArray = dateService
        .formatDate(smartLink.datetime_created, 'MM/DD/YYYY h:mm A', false)
        .split(' ');

      const auctionUrl =
        dateService.compareDates(smartLink.datetime_created, '2021-08-31') === -1
          ? smartLink.auction_url
          : smartLink.encoded_auction_url;

      return (
        <div className="smart-link-item" key={smartLink.bam_link_id}>
          <div className="details-container">
            <div className="product-name">
              {smartLink.product_info ? smartLink.product_info.item_data.name : ''}
            </div>
            <div className="shopLink-container">
              <div className="container-left">
                <span
                  className={`shopLink
								${this.state.copiedLinkID === smartLink.bam_link_id ? 'copied' : ''}`}
                >
                  {auctionUrl}
                </span>
              </div>
              <button
                className={`button-copy
									${this.state.copiedLinkID === smartLink.bam_link_id ? 'copied' : ''}
								`}
                onClick={() => this.copy(smartLink)}
              >
                {this.state.copiedLinkID === smartLink.bam_link_id ? 'Copied!' : 'Copy'}
              </button>
            </div>
            <div className="story-name">{smartLink.edit.name}</div>
            <div className="channel">{smartLink.edit.channel}</div>
            <hr className="hr" />
            <div className="date">
              Added {dateArray[0]} at {dateArray[1]} {dateArray[2]}
              <a
                className="button-originalURL"
                onClick={() => window.open(smartLink.original_url, '_blank')}
              >
                Go to Original URL
              </a>
            </div>
          </div>
        </div>
      );
    });

    return (
      <div className="created-links">
        <div className="header">
          <div>
            Links
            <img
              className={`info-icon${this.state.isInfoModalOpened ? ' active' : ''}`}
              src={dynamicInfo}
              alt="info"
              onClick={() => this.setState({ isInfoModalOpened: true })}
            />
          </div>
          <BasicDropdown
            items={this.filterOptions}
            selectItem={idx => this.setState({ selectedFilter: this.filterOptions[idx] })}
            dropdownLabel={this.state.selectedFilter.label}
          />
        </div>
        {infoModalElem}
        {smartLinks}
      </div>
    );
  }
}

export default CreatedLinks;
